import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://sepzqjijkuzmoyczfyzp.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlcHpxamlqa3V6bW95Y3pmeXpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzg4ODgyMTcsImV4cCI6MTk5NDQ2NDIxN30.PSpaSNeLuEPjHoldJ9guyBSVzyf47iXF2HKwI-okqLM'

const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase
